"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        trailingButton: (_a = {
                height: 44,
                padding: 0,
                fontSize: '0.875rem',
                marginTop: theme.spacing(0.5),
                width: function (props) { return (props.fullWidth ? '100%' : 135); }
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: 0,
            },
            _a),
    });
});
var TrailingButton = function (_a) {
    var className = _a.className, onClick = _a.onClick, disabled = _a.disabled, fullWidth = _a.fullWidth, variant = _a.variant, component = _a.component, children = _a.children;
    var classes = useStyles({ fullWidth: fullWidth });
    return (react_1.default.createElement(core_1.Button, { className: className + " " + classes.trailingButton, color: "primary", size: "large", onClick: onClick, disabled: disabled, fullWidth: fullWidth, variant: variant, component: component }, children));
};
exports.default = TrailingButton;
